import { mapState } from 'vuex';
import themeToggle from "@/components/assets/themetoggle/index.vue";

import _ from 'underscore';
import f from '@/application/shared/functions.js';

export default {
	name: 'leftmenu',
	props: {
	},

	components : {
		themeToggle
	},

	data : function(){

		return {
			loading : false,
			version : process.env.VUE_APP_VERSION,
			footerFocused : false,
			leftmenudirections : {
				left : {
                    trueshold : 1,
                    distance : 100,
                    direction : 'left'
                }  
			}
			
		}

	},

	created : () => {

	},

	watch: {
		path : function(){
			this.close()
		}
		
	},
	computed: mapState({
		auth : state => state.auth,
		mobileview : state => state.mobileview,
		opened : state => state.leftmenuOpened,
		isAndroid : function(){
			return f.isAndroid()
		},
		path : function(){
            return this.$route.path
        },

		active : function(){

			var path = this.$route.path


			var sorted = _.sortBy(this.items, (i) => {
				return i.route ? -i.route.length : 0
			})


			var r = _.find(sorted, function(i){
				
				if(i.route == '/') return path == i.route

				return path.indexOf(i.route) > -1 || (i.childrens && _.find(i.childrens, (i) => {
					return path.indexOf(i) > -1
				}))
			})

			if(r) return r.id

			return ''
		},

		items : function(state){

			var mobile = this.mobileview

			var items = _.filter(this.allitems, (item) => {
				return (typeof item.mobile == 'undefined' || item.mobile == mobile)
			})

			return this.core.user.extendByFeatures(items)
		},

		allitems : function(){

			if(!this.auth){
				return [
					{
						route : '/signin',
						id : 'signin',
						text : 'app.signin',
						icon : "fas fa-sign-in-alt",
					},

					{
						route : '/registration',
						id : 'registration',
						text : 'app.registration',
						icon : "fas fa-user-plus",
					},
				]
			}

			return _.filter([
				
				

				{
					route : '/panel',
					id : 'panel',
					text : 'app.panel',
					icon : "fas fa-cog",
					features : ['admin', 'team', 'moderation', 'promo', 'promounmoderated']
				},

				{
					route : '/chats',
					id : 'chats',
					text : 'app.chats',
					icon : "fas fa-comments",
					features : ['chats']
				},

				


				{
					route : '/chat',
					id : 'chat',
					text : 'snippity.stories',
					icon : "fas fa-kiwi-bird"
				},

				{
					route : '/courses',
					id : 'courses',
					text : 'snippity.courses',
					icon : "fas fa-stroopwafel"
				},

				/*f.deep(this.core, 'appInfo.snippity.settings.coursesEnabled') || this.core.user.checkFeatures(['admin']) ? {
					route : '/courses',
					id : 'courses',
					text : 'snippity.courses',
					icon : "fas fa-stroopwafel"
				} : null,*/

				{
					route : '/profile',
					id : 'profile',
					text : 'menu.profile',
					icon : "fas fa-user",
				},
			], (v) => {
				return v
			})
		}
	}),

	methods : {
		

		leftmenuendswipe: function () {
			this.$store.commit("leftmenuOpened", false);
        },
		explore : function(){
			this.core.vueapi.explore()
		},
		notifications : function(id){
			var c = this.$store.state.updates ? (this.$store.state.updates[id] || 0) : 0

			return c
		},
		/*signout : function(){
			this.core.user.signout()
			this.$router.push('/')
		},*/

		open : function(item){
			if (item.route) {
				this.$router.push(item.route).catch(e => {})
				this.close()
			}

			if(item.action) item.action()
		},

		close : function(){
			this.$store.commit("leftmenuOpened", false);
		},

		menu : function(){
			this.core.vueapi.fastmenu()
		},

		mouseoverFooter: function(){
			this.footerFocused = true
		},

		mouseleaveFooter: function(){
			this.footerFocused = false
		}
	}
}